@if (message) {
    <div
        class="multi-returns-message-popup"
        [ngClass]="{
            'multi-returns-message-popup--highlight': isHighlighted,
            'multi-returns-message-popup--ios': isiOS,
            'multi-returns-message-popup--showAccaupdatedinfo': isShowAccaUpdatedInfo,
        }"
        [innerHtml]="message"
        [@multiReturnAnimation]="{ value: animationState, params: { topTransformValue: topTransformValue } }"></div>
}
